import axios from "axios";

export const getPresentation = ({ target, owner, token, period }) => {
  const requestUrl = `/data/presentation`;

  let params = {
    target: target,
    owner: owner,
    access_token: token,
    period: period
  };

  return axios.get(requestUrl, {
    params
  });
};

export const savePresentation = ({
  id,
  owner,
  target,
  date,
  dashboard,
  isPrepared,
  isPresented,
  isFrozen,
  presenters,
  thankingSlide,
  questionsSlide,
  extraSlides,
  hiddenSlides,
  period
}) => {
  const requestUrl = `/data/presentation/save`;

  let formData = new FormData();
  id && formData.append("presentationId", id);
  formData.append("owner", owner);
  formData.append("target", target);
  formData.append("dashboard", JSON.stringify(dashboard));
  formData.append("date", date ? date : "");
  formData.append("isPrepared", isPrepared);
  formData.append("isPresented", isPresented);
  formData.append("isFrozen", isFrozen);
  formData.append("presentersIds", JSON.stringify(presenters));
  formData.append("thankingSlide", thankingSlide);
  formData.append("questionsSlide", questionsSlide);
  formData.append("extraSlides", JSON.stringify(extraSlides));
  formData.append("hiddenSlides", JSON.stringify(hiddenSlides));
  formData.append("period", period);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/presentation.js